import { makeEntityScaffold } from '@classpass/saga-tools';
import URLS from 'constants/urls';
import { transformKeysToCamelCase } from 'helpers/core';

const handler = ({ httpClient }) => {
  const endpoint = URLS.user.getConversationLimit;
  return httpClient
    .get(endpoint)
    .then(transformKeysToCamelCase)
    .then(data => data.data);
};

export default makeEntityScaffold('USER_SMS_CONVERSATION_LIMIT_STATUS', handler);
